import request from '@/utils/request'

// 商品列表
export const goods_type_list=(data)=>{
  return request({
    url: '/erp/base-goods-cate/all',
    method: 'get',
    data
  })
}

// 商品自定义商品分类删除
export const goods_type_del=(data)=>{
  return request({
    url: '/erp/base-goods-cate/del',
    method: 'post',
    data
  })
}
// 商品自定义分类编辑
export const goods_type_edit=(data)=>{
  return request({
    url: '/erp/base-goods-cate/edit',
    method: 'post',
    data
  })
}


// 商品列表
export const goods_list=(data)=>{
  return request({
    url: '/erp/base-goods-cate/get-goods',
    method: 'post',
    data
  })
}

// 商品转移
export const goods_transfor=(data)=>{
  return request({
    url: '/erp/base-goods-cate/swap',
    method: 'post',
    data
  })
}

// 商品移除
export const goods_del=(data)=>{
  return request({
    url: '/erp/base-goods-cate/delete-goods',
    method: 'post',
    data
  })
}


